/* eslint-disable no-const-assign */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import { config } from 'utils/config';
import { callApi, showSweetAlert, showNotify } from 'utils/utils'; 
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import YupValidator from 'utils/YupValidator';
import * as yup from 'yup'; 
import FieldText from 'components/Controls/FieldText';
import FieldNumber from 'components/Controls/FieldNumber';
import moment from 'moment'; 
import {
  Card, 
  CardBody, 
  Row,
  Col,
  FormGroup,
  Label,
  CardHeader,
  CardFooter,
} from 'reactstrap'; 
import PageContent from 'layouts/PageContent'; 
import HeaderTablet from '../../Common/Header/HeaderTablet.jsx'; 
import PrincipalHeader from '../../Common/Header/PrincipalHeader.jsx';
import '../DashboardUtilization/DashboardUtilizationScreen.scss'; 
import { useHistory, Link } from "react-router-dom"; 
import Highcharts from 'highcharts'; 
import HighchartsReact from 'highcharts-react-official';

const DashboardScrapScreen = (props) => {
  const { t, i18n } = useTranslation(['tablets', 'common']);
  const [OperationCheckInList, setOperationCheckInList] = useState([]);
  const [ClaveArticulo, setClaveArticulo] = useState(null);
  const [ClaArticulo, setClaArticulo] = useState(null);
  const [NomArticulo, setNomArticulo] = useState(null);
  const [Cajas, setCajas] = useState(null);
  const [ClaTurno, setClaTurno] = useState(null);
  const [NomTurno, setNomTurno] = useState(null);
  const [ClaAreaProduccion, setClaAreaProduccion] = useState(null);
  const [NomAreaProduccion, setNomAreaProduccion] = useState(null);
  const [NomCelda, setNomCelda] = useState(null);  
  const [errors, setErrors] = useState({});
  const [ClaveCelda, setClaveCelda] = useState(null);
  const [ClaCelda, setClaCelda] = useState(null);
  const [FechaInicial, setFechaInicial] = useState(null);
  const [FechaFinal, setFechaFinal] = useState(null);
  const [NomZona, setNomZona] = useState('')
  const [ColorZona, setColorZona] = useState(null);
  const [ResultadoZona, setResultadoZona] = useState(null);
  const [DashboardScrapSemanal, setDashboardScrapSemanal] = useState([]);
  const [DashboardScrapSemanaActual, setDashboardScrapSemanaActual] = useState([]);
  const [IntervaloRojo, setIntervaloRojo] = useState(null);
  const [IntervaloAmarillo	, setIntervaloAmarillo	] = useState(null);
  const [IntervalorVerde, setIntervalorVerde] = useState(null);
  const homeScreenLink = useRef();

  // const IdCelda = props.IdCelda !== undefined ? props.IdCelda : null;
  let IdCelda = null
  
  if(props.location!==undefined){
    const params = queryString.parse(props.location.search);
    IdCelda = params !== undefined ? params.IdCelda : null;
  }
  

  useEffect(() => { 
    OnloadDashboardScrapScreen(IdCelda);    
  }, []);

  const OnloadDashboardScrapScreen = (pIdCelda) => {  
    setClaveArticulo(null);
    const paramsService = {};
    const urlWebService = `${config.UrlApiProject}Operations/GetOperationOnloadDashboardScrapScreen?IdCelda=${pIdCelda}`;
    callApi(urlWebService, 'GET', paramsService, (response) => {
      const DashboardScrapHead =
        response.data.DashboardScrapHead.length > 0 ? response.data.DashboardScrapHead[0] : {};            
        setNomArticulo(DashboardScrapHead.NomArticulo);
        setClaArticulo(DashboardScrapHead.ClaArticulo);        
        setClaveArticulo(DashboardScrapHead.ClaveArticulo);    
        setCajas(DashboardScrapHead.Cajas);        
        setClaTurno(DashboardScrapHead.ClaTurno);
        setNomTurno(DashboardScrapHead.NomTurno);
        setClaAreaProduccion(DashboardScrapHead.ClaAreaProduccion);
        setNomAreaProduccion(DashboardScrapHead.NomAreaProduccion);        
        setNomCelda(DashboardScrapHead.NomCelda); 
        setClaveCelda(DashboardScrapHead.ClaveCelda);
        setClaCelda(DashboardScrapHead.ClaCelda);
        setFechaInicial(DashboardScrapHead.FechaInicial);
        setFechaFinal(DashboardScrapHead.FechaFinal);
        setNomZona(DashboardScrapHead.NombreZona);
        setColorZona(DashboardScrapHead.ColorZona);
        setResultadoZona(DashboardScrapHead.ResultadoZona);
        setIntervaloRojo(DashboardScrapHead.IntervaloRojo);
        setIntervaloAmarillo(DashboardScrapHead.IntervaloAmarillo);
        setIntervalorVerde(DashboardScrapHead.IntervalorVerde);
        setDashboardScrapSemanal(response.data.DashboardScrapSemanal);
        setDashboardScrapSemanaActual(response.data.DashboardScrapSemanaActual);
    });
  }; 

  const subHeader = (  
    <HeaderTablet
      ClaTurno={ClaTurno}
      NomTurno={NomTurno}
      ClaAreaProduccion={ClaAreaProduccion}
      NomAreaProduccion={NomAreaProduccion}
      IdCelda={IdCelda}
      NomCelda={NomCelda}
      ClaveCelda={ClaveCelda}
    >
    </HeaderTablet> 
  )

  const getColorByID = (colorID) =>
  {
    return colorID === null ? '#d9d9d9'
           : colorID === 1 ?   '#00b050'
           : colorID === 2 ?   '#fb927c'
           : colorID === 3 ?   '#e74545'
           : colorID === 4 ?   '#ae123a'
           : ''
  }

  const getFaceIconClass = (colorID) =>
  {
    return  colorID === null ? 'fas fa-laugh fa-lg'
           : colorID === 1 ?   'fas fa-laugh fa-lg'
           : colorID === 2 ?   'fas fa-frown fa-lg'
           : colorID === 3 ?   'fas fa-frown fa-lg'
           : colorID === 4 ?   'fas fa-meh fa-lg'
           : ''
  }

  const ScrapChartCfg = { 
    chart: {
        type: 'gauge',
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        height: '50%'
    },

    title: {
        text: '',
        style: {
          display: 'none'
        }
    },

    pane: {
        startAngle: -90,
        endAngle: 89.9,
        background: null,
        center: ['50%', '60%'],
        size: '100%'
    },

    // the value axis
    yAxis: {
        min: 0,
        max: 15,
        tickPixelInterval: 10,
        tickPosition: 'inside',
        tickColor: Highcharts.defaultOptions.chart.backgroundColor || '#FFFFFF',
        tickLength: 20,
        tickWidth: 1,
        minorTickInterval: null,
        labels: {
            distance: 15,
            style: {
                fontSize: '10px'
            }
        },
        plotBands: [{
           from: 0,
           to: 0,
           color: '#d9d9d9', // 
           thickness: 10
        },{
            from: .1,
            to: IntervalorVerde,
            color: '#55BF3B', // 
            thickness: 10
        }, {
            from: IntervalorVerde,
            to: IntervaloAmarillo,
            color: '#fb927c', // 
            thickness: 10
        }, {
            from: IntervaloAmarillo,
            to: IntervaloRojo,
            color: '#e74545', // 
            thickness: 10
        }, {
          from: IntervaloRojo,
          to: 15,
          color: '#ae123a', // 
          thickness: 10
        }]
    },

    series: [{
        name: 'Scrap',
        data: [ResultadoZona],
        tooltip: {
            valueSuffix: ' %',
            enabled: false
        },
        dataLabels: {
            format: '{y} %', 
            borderWidth: 0,
            color: getColorByID(ColorZona),
            style: {
                fontSize: '18px'
            }
        },
        dial: {
            radius: '100%',
            backgroundColor: 'gray',
            baseWidth: 6,
            baseLength: '0%',
            rearLength: '0%'
        },
        pivot: {
            backgroundColor: 'gray',
            radius: 3
        }

    }]

  }
  

  return (
    <>
      <PrincipalHeader IsHomeScreen={false}></PrincipalHeader> 
      <PageContent title="Dashboard" subheader={subHeader}>      
        <Row className='pt-1 align-items-start'>
          <Col lg={6} md={6} sm={12} xs={12}>
            <Card>
              <CardHeader className='production-dashboard-zone'>
                <Row>
                  <Col className='text-center'><span className="h1 white-color">{t('tablets:ScrapForZone')} - {NomZona} </span></Col>
                </Row>
              </CardHeader>
              <CardBody className='production-dashboard-card-body'> 
                <Row className='align-items-start'>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <HighchartsReact highcharts={Highcharts} options={ScrapChartCfg} />                    
                  </Col> 
                </Row>
              </CardBody>
              <CardFooter>
                <Row>
                  <Col className='text-center'> 
                    <small> 
                      <i className="fas fa-calendar-alt"></i>&nbsp;
                      <b>{ FechaInicial === null ? '' : moment(FechaInicial).format("MMMM Do YYYY")}
                      &nbsp;-&nbsp;
                        { FechaFinal === null ? '' : moment(FechaFinal).format("MMMM Do YYYY")}
                      </b>
                    </small> 
                  </Col>
                </Row>
              </CardFooter>
            </Card>
          </Col> 
          <Col lg={6} md={6} sm={12} xs={12}>
            <Card>
              <CardHeader className='production-dashboard-cell'>
                <Row>
                  <Col className='text-center'><span className="h1 white-color">{t('tablets:ScrapForCell')}</span></Col>
                </Row>
              </CardHeader>
              <CardBody className='production-dashboard-card-body'> 
                <Row className='align-items-start'>
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <Row className='pt-1'>
                      <Col>
                        <div className='production-average-by-week light-gray'>
                          <b><span>{t('tablets:AverageByweek')}</span></b>
                        </div> 
                        {DashboardScrapSemanal.length >= 1 ? 
                        (  
                          DashboardScrapSemanal.map((element, index) => {
                              return ( 
                                <div className='production-dashboard-row'>
                                  <Row>
                                    <Col lg={6} md={6} sm={7} xs={7}>
                                      <Row>
                                        <Col>
                                          <span className="tablet-label">{t('tablets:week')} {element.NumeroSemana} <i className={getFaceIconClass(element.Color)}></i></span>
                                          <div> 
                                            <small>
                                              { element.FechaInicial === null ? '' : moment(element.FechaInicial).format("MMMM DD") }
                                              &nbsp;-&nbsp;
                                              {
                                                  element.FechaFinal === null ? '' : moment(element.FechaFinal).format("DD")
                                                }  
                                            </small> 
                                          </div>
                                        </Col>
                                      </Row> 
                                    </Col>
                                    <Col lg={6} md={6} sm={5} xs={5} className="text-center">
                                      <span className='resultado-utilizacion' style={{ color: getColorByID(element.Color)}}>
                                        {
                                          element.Resultado === null ? ' - '
                                          : (
                                            <>
                                              {element.Resultado} %
                                            </>
                                            ) 
                                        }
                                      </span>
                                    </Col>
                                  </Row> 
                                </div> 
                              );
                            }) 
                      ) : (
                        <></>
                      )} 

                      </Col>    
                    </Row>              
                  </Col> 
                  <Col lg={6} md={6} sm={6} xs={6}>
                    <Row className='pt-1'>
                      <Col>
                        <div className='production-current-week light-gray'>
                          <b><span>{t('tablets:CurrentWeek')}</span></b>
                        </div>
                        {DashboardScrapSemanaActual.length >= 1 ? 
                        (  
                          DashboardScrapSemanaActual.map((element, index) => {
                              return ( 
                                <div className='production-dashboard-row'>
                                  <Row>
                                    <Col lg={6} md={6} sm={7} xs={7}>
                                      <Row>
                                        <Col>
                                          <span className="tablet-label">{element.NomDia} <i className={getFaceIconClass(element.Color)}></i></span>
                                          <div> 
                                            <small>
                                              { element.FechaDia === null ? '' : moment(element.FechaDia).format("MMMM DD") } 
                                            </small> 
                                          </div>
                                        </Col>
                                      </Row> 
                                    </Col>
                                    <Col lg={6} md={6} sm={5} xs={5} className="text-center">
                                      <span className='resultado-utilizacion' style={{ color: getColorByID(element.Color)}}>
                                        {
                                          element.Resultado === null ? ' - '
                                          : (
                                            <>
                                              {element.Resultado} %
                                            </>
                                            ) 
                                        }
                                      </span>
                                    </Col>
                                  </Row> 
                                </div> 
                              );
                            }) 
                      ) : (
                        <></>
                      )} 
                      </Col>    
                    </Row>              
                  </Col> 
                </Row>
                <Row>
                  <Col>&nbsp;</Col>
                </Row>
              </CardBody> 
            </Card>
          </Col>
        </Row>
        <Link 
          ref={homeScreenLink} 
          to={
               { pathname: "CellHomeMenuScreen", search: `?IsDeviceAssignedOnCell=true` }
             }
        >
        </Link> 
      </PageContent> 
    </>
  );
};

export default DashboardScrapScreen;
